import React, { useState, useEffect } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import API from '../../utils/api';
import { Link } from 'react-router-dom';
import { Megaphone, Plus } from 'lucide-react';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';

const STATUS_MAP = {
  pending:      { label: 'Menunggu Tinjauan', color: '#92400E', bg: '#FFFBEB', border: '#FDE68A' },
  under_review: { label: 'Sedang Ditinjau',   color: '#1e40af', bg: '#EFF6FF', border: '#BFDBFE' },
  approved:     { label: 'Disetujui',          color: '#065F46', bg: '#ECFDF5', border: '#A7F3D0' },
  rejected:     { label: 'Ditolak',            color: '#991B1B', bg: '#FEF2F2', border: '#FECACA' },
  active:       { label: 'Sedang Tayang',      color: '#065F46', bg: '#ECFDF5', border: '#6EE7B7' },
  ended:        { label: 'Selesai Tayang',     color: '#6B7280', bg: '#F9FAFB', border: '#E5E7EB' },
};

function AdBadge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.pending;
  return (
    <span style={{
      fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 100,
      background: s.bg, color: s.color, border: `1px solid ${s.border}`,
      whiteSpace: 'nowrap',
    }}>{s.label}</span>
  );
}

function fmt(d) {
  try { return format(new Date(d), 'd MMM yyyy', { locale: id }); } catch { return '-'; }
}

export default function MyAds() {
  const { settings } = useSiteSettings();
  const sn = settings.siteName;
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/ads/my')
      .then(r => { setAds(r.data.ads || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout title="Iklan Saya" subtitle="Pantau status pengajuan iklan Anda">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
        <Link to="/pasang-iklan" className="btn btn-primary btn-sm">
          <Plus size={14} /> Ajukan Iklan Baru
        </Link>
      </div>

      {loading ? (
        <div className="ki-card">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="shimmer" style={{ height: 52, borderRadius: 8, marginBottom: 10 }} />
          ))}
        </div>
      ) : ads.length === 0 ? (
        <div className="ki-card" style={{ textAlign: 'center', padding: '60px 24px' }}>
          <Megaphone size={40} style={{ color: 'var(--ki-text-faint)', margin: '0 auto 12px', display: 'block' }} />
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>Belum ada pengajuan iklan</div>
          <p style={{ color: 'var(--ki-text-muted)', marginBottom: 20, fontSize: 14 }}>
            Pasang iklan untuk menjangkau pembaca {sn}.
          </p>
          <Link to="/pasang-iklan" className="btn btn-primary">Pasang Iklan Pertama</Link>
        </div>
      ) : (
        <div className="ki-card" style={{ padding: 0, overflow: 'hidden' }}>
          <div className="ki-table-wrap">
          <table className="ki-table">
            <thead>
              <tr>
                <th>Perusahaan</th>
                <th>Tipe</th>
                <th>Periode Tayang</th>
                <th>Status</th>
                <th>Diajukan</th>
                <th>Catatan Admin</th>
              </tr>
            </thead>
            <tbody>
              {ads.map(a => (
                <tr key={a._id}>
                  <td>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{a.companyName}</div>
                    <div style={{ fontSize: 11, color: 'var(--ki-text-faint)' }}>{a.contactEmail}</div>
                  </td>
                  <td style={{ fontSize: 13 }}>
                    {a.adType === 'image' ? 'Banner Gambar' : 'Teks'}
                  </td>
                  <td style={{ fontSize: 12, color: 'var(--ki-text-faint)', whiteSpace: 'nowrap' }}>
                    {fmt(a.startDate)} s.d. {fmt(a.endDate)}
                  </td>
                  <td><AdBadge status={a.status} /></td>
                  <td style={{ fontSize: 12, color: 'var(--ki-text-faint)' }}>{fmt(a.createdAt)}</td>
                  <td style={{ fontSize: 12, color: 'var(--ki-text-faint)', maxWidth: 200 }}>
                    {a.adminNotes || <span style={{ opacity: 0.4 }}>-</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
